export default "__VITE_ASSET__ff99e096__"